module.exports = __webpack_public_path__ + "img/ios.49c44dc0.png";